import { render } from "./navView.vue?vue&type=template&id=679d78bd"
import script from "./navView.vue?vue&type=script&lang=js"
export * from "./navView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__